import { render, staticRenderFns } from "./group_list.vue?vue&type=template&id=0663e294"
import script from "./group_list.vue?vue&type=script&lang=js"
export * from "./group_list.vue?vue&type=script&lang=js"
import style0 from "./group_list.vue?vue&type=style&index=0&id=0663e294&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports